<template>
  <div class="view-toggle">
    <label class="view-toggle-switch">
      <input 
        type="checkbox" 
        :checked="modelValue === 'grid'" 
        @change="handleChange" 
      />
      <span class="view-toggle-slider">
        <span class="view-toggle-text view-toggle-text-left">Table</span>
        <span class="view-toggle-text view-toggle-text-right">Grid</span>
      </span>
    </label>
  </div>
</template>

<script>
import './ViewToggle.css';

export default {
  name: 'ViewToggle',
  props: {
    modelValue: {
      type: String,
      default: 'table',
      validator: (value) => ['table', 'grid'].includes(value)
    }
  },
  emits: ['update:modelValue'],
  methods: {
    handleChange(event) {
      const newValue = event.target.checked ? 'grid' : 'table';
      this.$emit('update:modelValue', newValue);
    }
  }
}
</script>
